export const REQUESTED_PANEL_DATA = 'REQUESTED_PANEL_DATA';
export const RECEIVED_PANEL_DATA = 'RECEIVED_PANEL_DATA';
export const REQUESTED_LISTS = 'REQUESTED_LISTS';
export const RECEIVED_LISTS = 'RECEIVED_LISTS';
export const INITIALIZED_APP = 'INITIALIZED_APP';
export const REQUESTED_DATA_CHECK = 'REQUESTED_DATA_CHECK';
export const RECEIVED_DATA_CHECK = 'RECEIVED_DATA_CHECK';
export const REPORT_RESOLVED = 'REPORT_RESOLVED';
export const REQUESTED_ATTRIBUTES = 'REQUESTED_ATTRIBUTES';
export const RECEIVED_ATTRIBUTES = 'RECEIVED_ATTRIBUTES';
export const NOTIFICATION_CREATED = 'NOTIFICATION_CREATED';
export const REQUESTED_CAMPAIGNS = 'REQUESTED_CAMPAIGNS';
export const RECEIVED_CAMPAIGNS = 'RECEIVED_CAMPAIGNS';
export const REQUESTED_TOP_SERIES = 'REQUESTED_TOP_SERIES';
export const RECEIVED_TOP_SERIES = 'RECEIVED_TOP_SERIES';
export const RECEIVED_TOP_SERIES_FAILURE = 'RECEIVED_TOP_SERIES_FAILURE';
export const REQUESTED_HUB_SETTING = 'REQUESTED_HUB_SETTING';
export const RECEIVED_HUB_SETTING = 'RECEIVED_HUB_SETTING';
export const EVENT_DELETE_FAILED = 'EVENT_DELETE_FAILED';
export const EVENT_DELETED = 'EVENT_DELETED';
export const EVENT_DETAILS_REQUESTED = 'EVENT_DETAILS_REQUESTED';
export const EVENT_DETAILS_RECEIVED = 'EVENT_DETAILS_RECEIVED';
export const EVENT_DETAILS_FAILED = 'EVENT_DETAILS_FAILED';
export const EVENT_UPDATED = 'EVENT_UPDATED';
export const EVENT_UPDATE_FAILED = 'EVENT_UPDATE_FAILED';
export const EVENT_BATCH_APPROVE = 'EVENT_BATCH_APPROVE';
export const EVENT_BATCH_DELETE = 'EVENT_BATCH_DELETE';
export const EVENT_BATCH_UNDELETE = 'EVENT_BATCH_UNDELETE';
export const EVENT_BATCH_APPROVE_FAILED = 'EVENT_BATCH_APPROVE_FAILED';
export const EVENT_BATCH_DELETE_FAILED = 'EVENT_BATCH_DELETE_FAILED';
export const EVENT_BATCH_UNDELETE_FAILED = 'EVENT_BATCH_UNDELETE_FAILED';
export const EVENTS_COUNT_REQUESTED = 'EVENTS_COUNT_REQUESTED';
export const EVENTS_COUNT_RECEIVED = 'EVENTS_COUNT_RECEIVED';
export const EVENTS_COUNT_FAILED = 'EVENTS_COUNT_FAILED';
export const EVENTS_ALL_REQUESTED = 'EVENTS_ALL_REQUESTED';
export const EVENTS_ALL_RECEIVED = 'EVENTS_ALL_RECEIVED';
export const EVENTS_ALL_FAILED = 'EVENTS_ALL_FAILED';
export const REQUESTED_CUSTOM_JS = 'REQUESTED_CUSTOM_JS';
export const RECEIVED_CUSTOM_JS = 'RECEIVED_CUSTOM_JS';
export const CREATE_CUSTOM_JS_SUCCESS = 'CREATE_CUSTOM_JS_SUCCESS';
export const CREATE_CUSTOM_JS_FAILED = 'CREATE_CUSTOM_JS_FAILED';
export const UPDATE_CUSTOM_JS_SUCCESS = 'UPDATE_CUSTOM_JS_SUCCESS';
export const UPDATE_CUSTOM_JS_FAILED = 'UPDATE_CUSTOM_JS_FAILED';
export const DELETE_CUSTOM_JS_SUCCESS = 'DELETE_CUSTOM_JS_SUCCESS';
export const DELETE_CUSTOM_JS_FAILED = 'DELETE_CUSTOM_JS_FAILED';
export const REQUESTED_TRACKING_URLS = 'REQUESTED_TRACKING_URLS';
export const RECEIVED_TRACKING_URLS = 'RECEIVED_TRACKING_URLS';
export const RECEIVED_TRACKING_URLS_FAILURE = 'RECEIVED_TRACKING_URLS_FAILURE';
export const TRACKING_URL_CREATE_SUCCESS = 'TRACKING_URL_CREATE_SUCCESS';
export const TRACKING_URL_CREATE_FAILURE = 'TRACKING_URL_CREATE_FAILURE';
export const TRACKING_URL_DELETE_SUCCESS = 'TRACKING_URL_DELETE_SUCCESS';
export const TRACKING_URL_DELETE_FAILURE = 'TRACKING_URL_DELETE_FAILURE';
export const REQUESTED_ANALYTICS_VIEWS = 'REQUESTED_ANALYTICS_VIEWS';
export const RECEIVED_ANALYTICS_VIEWS = 'RECEIVED_ANALYTICS_VIEWS';
export const REQUESTED_PRODUCT_LEVELS = 'REQUESTED_PRODUCT_LEVELS';
export const RECEIVED_PRODUCT_LEVELS = 'RECEIVED_PRODUCT_LEVELS';
export const REQUESTED_ANALYTICS_VIEW_TOTAL = 'REQUESTED_ANALYTICS_VIEW_TOTAL';
export const RECEIVED_ANALYTICS_VIEW_TOTAL = 'RECEIVED_ANALYTICS_VIEW_TOTAL';
export const REQUESTED_SAVED_FILTERS = 'REQUESTED_SAVED_FILTERS';
export const RECEIVED_SAVED_FILTERS = 'RECEIVED_SAVED_FILTERS';
export const REQUESTED_CURRENCY_INFO = 'REQUESTED_CURRENCY_INFO';
export const RECEIVED_CURRENCY_INFO = 'RECEIVED_CURRENCY_INFO';
export const RECEIVED_CURRENCY_INFO_FAILURE = 'RECEIVED_CURRENCY_INFO_FAILURE';
export const EXPERIMENT_TREATMENTS_REQUESTED = 'EXPERIMENT_TREATMENTS_REQUESTED';
export const EXPERIMENT_TREATMENTS_RECEIVED = 'EXPERIMENT_TREATMENTS_RECEIVED';
export const EXPERIMENT_TREATMENTS_FAILED = 'EXPERIMENT_TREATMENTS_FAILED';
export const FETCH_INTEGRATIONS_STARTED = 'FETCH_INTEGRATIONS_STARTED';
export const FETCH_INTEGRATIONS_SUCCEEDED = 'FETCH_INTEGRATIONS_SUCCEEDED';
export const FETCH_INTEGRATIONS_FAILED = 'FETCH_INTEGRATIONS_FAILED';
export const FETCH_SITES_STARTED = 'FETCH_SITES_STARTED';
export const FETCH_SITES_SUCCEEDED = 'FETCH_SITES_SUCCEEDED';
export const FETCH_SITES_FAILED = 'FETCH_SITES_FAILED';
export const PERSIST_RESOLVED_REPORT = 'PERSIST_RESOLVED_REPORT';
export const REQUESTED_OPTINS = 'REQUESTED_OPTINS';
export const RECEIVED_OPTINS = 'RECEIVED_OPTINS';
export const UPDATE_COLUMNS = 'UPDATE_COLUMNS';
export const HISTORY_METHOD_CALLED = 'HISTORY_METHOD_CALLED';